export const groupChunksByFileType = (chunks) => {
    return chunks.reduce((chunksByFileType, chunk) => {
        const fileType = chunk.fileType;
        if (!chunksByFileType[fileType]) {
            chunksByFileType[fileType] = [];
        }
        chunksByFileType[fileType].push(chunk);
        return chunksByFileType;
    }, {});
};
//# sourceMappingURL=utils.js.map